<template>
  <div class="">
    <div class="content">
      <div v-if="user" class="single">
        <AddEditUser></AddEditUser>
      </div>
      <div v-else>
        <div class="meta">
          <div class="filter">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('admin.views.users.filter')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="buttons">
            <v-btn v-if="!user" outline @click="add" color="success"
              >{{ $t('admin.views.users.create') }}</v-btn
            >
          </div>
        </div>
        <v-data-table
          :custom-filter="filter"
          :headers="headers"
          :items="users"
          class="elevation-1"
          :no-results-text="message_not_found"
          :rows-per-page-items="pagination"
          :search="search"
          :rows-per-page-text="message_rows_per_page"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.locations | printRestaurants }}</td>
            <td>{{ props.item.type | printRol }}</td>
            <td v-if="props.item.active == 'false'">Inactivo</td>
            <td v-else>Activo</td>
            <td>
              <v-icon @click="edit(props.item)">edit</v-icon
              ><v-icon @click="remove(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import AddEditUser from "@/components/domain/users/AddEditUser";

export default {
  name: "Users",
  props: { page: String },
  components: { AddEditUser },
  data() {
    return {
      headers: [
        { text: i18n.t('general.name'), value: "name" },
        { text: i18n.t('general.email'), value: "email" },
        { text: i18n.t('general.phone'), value: "phone" },
        { text: i18n.t('general.headers.restaurant'), value: "restaurant" },
        { text: i18n.t('general.type'), value: "type" },
        { text: i18n.t('general.status'), value: "active" },
        { text: "", value: "actions", width: "100px" }
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t('admin.views.users.message_not_found'),
      message_rows_per_page: i18n.t('admin.views.users.message_rows_per_page'),
      pagination: [10, 20, 30, { text: i18n.t('general.all'), value: -1 }],
      add_user: {
        id: -1,
        name: "",
        email: "",
        phone: "",
        locations: [],
        active: "1",
        type: 1
      }
    };
  },
  computed: {
    users() {
      var users = ObjectToArray(this.$store.getters["user/getUsers"]);
      return users;
    },
    user() {
      return this.$store.getters["user/getUserSelected"];
    },
    userLogged() {
      return this.$store.getters["user/getUser"];
    }
  },
  methods: {
    edit(user) {
      this.$store.commit("user/setSelectedUser", user);
    },
    remove(user) {
      var self = this;
      this.$popup.confirm(
        i18n.t('admin.views.users.popup.delete'),
        i18n.t('admin.views.users.popup.delete_message', { name: user.name }),
        i18n.t('general.delete'),
        i18n.t('general.cancel'),
        function() {
          self.$store.dispatch("user/removeUser", user.id);
        }
      );
    },
    add() {
      this.$store.commit("user/setSelectedUser", this.add_user);
    },
    filter(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(item.email, search.toLowerCase()) ||
          filter(item.phone, search) ||
          filter(item.name, search.toLowerCase())
        ) {
          aItems.push(item);
        }
      });
      return aItems;
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  filters: {
    printRestaurants: function(locations) {
      var sLocations = "";
      locations.forEach(location => {
        if (sLocations != "") sLocations += ", ";
        sLocations += location.site + " " + location.name;
      });

      return sLocations;
    },
    printRol: function(type) {
      var rol = "";
      if (type == 1) {
        rol = i18n.t('admin.views.users.role.franchisee');
      } else if (type == 2) {
        rol = i18n.t('admin.views.users.role.administrator');
      } else if (type == 3) {
        rol = i18n.t('admin.views.users.role.manager');
      } else if (type == 4) {
        rol = i18n.t('admin.views.users.role.restricted_administrator');
      } else if (type == 5) {
        rol = i18n.t('admin.views.users.role.consultant');
      } else {
        rol = i18n.t('admin.views.users.role.undefined');
      }
      return rol;
    }
  },
  created() {
    // IF USER TYPE IS != 1 GO TO HOME
    if (this.userLogged.type != 1) {
      this.$router.push({ name: "home" });
    }
    // ELSE
    else {
      this.$store.commit("setTitle", i18n.t('admin.views.users.name'));
      this.$store.commit("setMenuVisible", false);

      this.$store.dispatch("user/loadLocationUsers");

      if (Object.keys(this.$store.getters["user/getUsers"]).length == 0) {
        var self = this;
        this.$store.getters["user/loadLocationUsers"];
        this.$store.dispatch("user/loadLocationUsers").then(function() {
          switch (self.page) {
            case "edit":
              self.$store.commit(
                "user/setSelectedUserByID",
                self.$route.params.id
              );
              break;
            case "add":
              self.$store.commit("user/setSelectedUser", self.add_user);
              break;
            default:
              break;
          }
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px 50px;
  position: relative;

  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .filter {
      float: left;
      width: 400px;
    }
    .buttons {
      float: right;
    }
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
